import { render } from "./SalarySlip.vue?vue&type=template&id=20684377&scoped=true"
import script from "./SalarySlip.vue?vue&type=script&lang=js"
export * from "./SalarySlip.vue?vue&type=script&lang=js"

import "./salary-slip.scss?vue&type=style&index=0&id=20684377&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20684377"]])

export default __exports__